// Core imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

// Material imports
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

// Services
import { UserFeedbackService } from './user-feedback.service';

// Components
import { SnackbarComponent } from './snackbar/snackbar.component';
import { DialogComponent } from './dialog/dialog.component';

@NgModule({
    imports: [
        // Core imports
        CommonModule,
        FlexLayoutModule,
        // Material modules imports
        MatIconModule,
        MatSnackBarModule,
        MatButtonModule,
        MatDialogModule
    ],
    declarations: [
        SnackbarComponent,
        DialogComponent
    ],
    providers: [
        UserFeedbackService
    ],
    entryComponents: [
        SnackbarComponent,
        DialogComponent
    ]
})
export class UserFeedbackModule { }



// WEBPACK FOOTER //
// ./src/app/modules/user-feedback/user-feedback.module.ts